import React, { useMemo } from 'react';
import { connect } from 'umi';
import { ISingleCommonType, TTimeRangeOptionsItem } from '../../types';
import { useUpdateEffect } from 'ahooks';
import { SingleSelect, TSingleSelectType } from '../../components/SingleSelect';
import { singleMapStateToProps, singleMergeProps } from '../../connect/single';

export type TimeRangeSelectType = Omit<TSingleSelectType, 'options'> & {
  options: TTimeRangeOptionsItem[];
  filterOptions: (
    value: TTimeRangeOptionsItem[],
    filterValue: any,
  ) => TTimeRangeOptionsItem[];
};

function TimeRangeSelect({
  options,
  change,
  filterValue,
  value,
  filterOptions,
  ...props
}: TimeRangeSelectType & ISingleCommonType) {
  const realOptions = useMemo(() => {
    return filterOptions(options, filterValue);
  }, [filterValue.channels, filterValue.source]);

  useUpdateEffect(() => {
    if (value) {
      const index = realOptions.findIndex((item) => item.value === value);
      if (index === -1) {
        change(realOptions[0]?.value);
      }
    }
  }, [filterValue.channels, filterValue.source]);

  return (
    <SingleSelect
      filterValue={filterValue}
      change={change}
      value={value}
      options={realOptions}
      {...props}
    ></SingleSelect>
  );
}

export default connect(
  singleMapStateToProps,
  singleMergeProps,
)(TimeRangeSelect);
